// One booking action per screen. A page that renders its own booking button
// (deal/property header, list headers, desk, Shoots) claims the action while
// it's mounted; the mobile top bar then hides its shortcut so the screen never
// shows two equivalent "Book media" buttons.
import { useEffect, useSyncExternalStore } from "react";

let claims = 0;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

export function claimBookingAction() {
  claims += 1; emit();
  let done = false;
  return () => { if (!done) { done = true; claims -= 1; emit(); } };
}

export function bookingActionClaimed() { return claims > 0; }

export function useClaimBookingAction(active = true) {
  useEffect(() => (active ? claimBookingAction() : undefined), [active]);
}

export function useBookingActionClaimed() {
  return useSyncExternalStore(
    (f) => { subs.add(f); return () => subs.delete(f); },
    bookingActionClaimed,
    bookingActionClaimed,
  );
}
